import { Box, Button, Stack, Text, VStack } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { CalendarSecondaryButton } from '../../calendar/components/calendarUi';

const TemplatesPage = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const navigate = useNavigate();

  return (
    <VStack align="stretch" spacing={6} h="100%" bg="#F0F2F5" px={{ base: 4, md: 8 }} py={{ base: 6, md: 8 }}>
      <Box bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="24px" px={{ base: 5, md: 8 }} py={{ base: 6, md: 8 }} boxShadow="0 18px 40px rgba(15, 23, 42, 0.05)">
        <Stack spacing={4} maxW="720px">
          <Text fontSize="xs" textTransform="uppercase" letterSpacing="0.14em" fontWeight="800" color="gray.500">
            Templates
          </Text>
          <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight="800" color="gray.900">
            Template messaging is not ready for this inbox yet
          </Text>
          <Text color="gray.600" lineHeight="1.7">
            To protect WhatsApp Cloud API compliance, this inbox does not expose a fake or local-only template workflow. Free-text replies are allowed only while the 24-hour customer care window is open. When template sending is properly wired to backend-approved templates, this page can become the safe entry point for outbound template messages.
          </Text>
          <Stack direction={{ base: 'column', sm: 'row' }} spacing={3}>
            <Button
              bg="#128C7E"
              color="white"
              borderRadius="16px"
              _hover={{ bg: '#0F766E' }}
              onClick={() => navigate(`/organization/${orgId}/inbox/whatsapp/conversations`)}
            >
              Back to inbox
            </Button>
            <CalendarSecondaryButton onClick={() => navigate(`/organization/${orgId}/inbox/whatsapp/settings`)}>
              Open WhatsApp settings
            </CalendarSecondaryButton>
          </Stack>
        </Stack>
      </Box>
    </VStack>
  );
};

export default TemplatesPage;
